/**
 * Enum de status de rede.
 */
export const networkStatusTypes = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  UNDETERMINED: 'undetermined',
};

export default networkStatusTypes;
